import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import dayjs from "dayjs";

const useStyles = makeStyles({
  card: {
    marginBottom: 12,
    border: "1px solid #e0e0e0",
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
  },
  cardContent: {
    paddingBottom: 8,
  },
  header: {
    marginBottom: 12,
  },
  groupName: {
    fontWeight: 600,
    fontSize: 16,
    color: "#006EB3",
  },
  infoGrid: {
    marginTop: 8,
  },
  label: {
    fontSize: 12,
    color: "#666",
    marginBottom: 4,
  },
  value: {
    fontWeight: 500,
    fontSize: 14,
  },
  description: {
    fontSize: 14,
    color: "#444",
    lineHeight: 1.5,
  },
  cardActions: {
    padding: "8px 16px",
    paddingTop: 0,
  },
  noMembers: {
    fontSize: 13,
    textAlign: "center",
    padding: "8px 0",
    color: "#666",
  },
});

interface AdminGroupCardProps { group: { description?: string; member_details?: unknown[]; name?: React.ReactNode; start_date?: string; user?: React.ReactNode }; onViewMembers?: () => void; }

export default function AdminGroupCard({ group, onViewMembers }: AdminGroupCardProps): React.ReactElement {
  const classes = useStyles();

  const creationDate = dayjs(group.start_date).format("DD/MM/YYYY");
  const memberCount = group.member_details ? group.member_details.length : 0;
  const hasMembers = memberCount > 0;

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.cardContent}>
        <div className={classes.header}>
          <Typography className={classes.groupName}>{group.name}</Typography>
        </div>

        <Grid container spacing={2} className={classes.infoGrid}>
          <Grid item xs={12}>
            <Typography className={classes.label}>Description</Typography>
            <Typography className={classes.description}>
              {group.description?.length ? group.description : "N/A"}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography className={classes.label}>Number of Members</Typography>
            <Chip
              label={memberCount}
              size="small"
              color="primary"
              style={{ fontWeight: 600 }}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography className={classes.label}>Owner</Typography>
            <Typography className={classes.value}>{group.user}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography className={classes.label}>Creation Date</Typography>
            <Typography className={classes.value}>{creationDate}</Typography>
          </Grid>
        </Grid>
      </CardContent>

      <CardActions className={classes.cardActions}>
        {hasMembers ? (
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={onViewMembers}
          >
            View Members
          </Button>
        ) : (
          <Typography className={classes.noMembers} component="div">
            No Members
          </Typography>
        )}
      </CardActions>
    </Card>
  );
}
